const namespace = {
  sidebar: {
    ariaLabel: "Menu des scores",
    header: {
      title: "Catégories",
      backAction: "Retour au menu",
      toggle: {
        ariaLabel: "Basculer la barre latérale",
        ariaLabel_open: "Ouvrir la barre latérale",
        ariaLabel_close: "Fermer la barre latérale",
      },
    },
  },
  categoriesToggle: {
    toggleLabel: "Catégories",
    backAction: "Retour",
  },
  categories: {
    commute: "Transport",
    amenities: "Services",
    character: "Caractère",
    nature: "Nature",
    education: "Éducation",
    health: "Santé",
  },
  scoreComparison: {
    text: "Comparable à la moyenne de {{name}} de {{value}}",
    text_higher: "Supérieur à la moyenne de {{name}} de {{value}}",
    text_lower: "Inférieur à la moyenne de {{name}} de {{value}}",
  },
  poiSearchRadius: "Affichage des PO dans un rayon de {{radius}} {{unit}}",
  commute: {
    placeholder: "Faire une recherche...",
    clearSearch: "Effacer la recherche",
    resultsCount_one: "{{count}} résultat disponible.",
    resultsCount_other: "{{count}} résultats disponibles.",
    cta: "Calculer le trajet",
    cta_long: "Calculer le trajet",
    cta_short: "Calculer",
    viewRoute: "Voir l'itinéraire",
    travelTypeAriaLabel: "Type de trajet",
    travelTypes: {
      walking: "À pied",
      driving: "En voiture",
      cycling: "À vélo",
    },
    results: {
      noRoute: "Aucun itinéraire disponible.",
      trySuggestion: "Essayez une autre requête.",
      fastestRoute: "Itinéraire le plus rapide",
    },
  },
} as const;

export default namespace;
